namespace Areas.Ucla {
    "use strict";

    export function newDaUcopLink(e: any) {
        const dataGrid = e.component;
        e.data.daUclaId = dataGrid.option("DaUclaId");
    }    
}